import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const usePromedioDiario = (tipo) => {
  const [isLoading, setIsLoading] = useState(false);
  const [promedio, setPromedio] = useState([]);

  useEffect(() => {
    const getPromedio = async () => {
      setIsLoading(true);
      const token = localStorage.getItem("@Token");
      try {
        const response = await api.get(
          "api/proyeccion-diaria/promedio-captura-proyeccion-diaria/",
          {
            params: { tipo },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Token " + token,
            },
          },
        );
        setPromedio(response.data);
      } catch (error) {
        setPromedio([]);
      } finally {
        setIsLoading(false);
      }
    };
    getPromedio();
  }, [tipo]);

  return { promedio, isLoading };
};
